module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, _vm._l((_vm.chart), function(c, i) {
    return (_vm.chart.length > 0) ? _c('el-col', {
      key: i,
      attrs: {
        "sm": 24,
        "md": 12,
        "lg": _vm.mdAbove,
        "align": "center"
      }
    }, [(_vm.chart[i].total > 0) ? _c('pie-chart', {
      attrs: {
        "title": _vm.chart[i].title,
        "data": _vm.chart[i].data,
        "colors": _vm.chart[i].colors,
        "legend": _vm.posLegend
      }
    }) : _vm._e()], 1) : _vm._e()
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bda97a60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/charts/RequestsChart.vue
// module id = 1622
// module chunks = 0